<template>
  <div class="after-sales-page">
    <div class="page-header">
      <h2>售后记录</h2>
      <button class="btn btn-secondary" @click="$router.push('/orders')">返回订单</button>
    </div>

    <div v-if="loading" class="loading">加载中...</div>
    <div v-if="error" class="alert alert-danger">{{ error }}</div>

    <div v-if="!loading && records.length > 0" class="records-list">
      <div v-for="item in records" :key="item.id" class="card record-card">
        <div class="record-main">
          <div class="line"><strong>售后单号:</strong> {{ item.afterSalesId || ('AS-' + item.id) }}</div>
          <div class="line"><strong>商品名称:</strong> {{ item.productName || '-' }}</div>
          <div class="line"><strong>售后类型:</strong> {{ item.type || '-' }}</div>
          <div class="line"><strong>申请时间:</strong> {{ formatDateTime(item.createdAt) }}</div>
          <div class="line">
            <strong>状态:</strong>
            <span class="status" :class="statusClass(item.status)">{{ item.status || '待处理' }}</span>
          </div>
        </div>
        <div class="record-actions">
          <button class="btn" @click="openDetail(item)">查看详情</button>
        </div>
      </div>
    </div>

    <div v-if="!loading && records.length === 0" class="alert alert-info">暂无售后记录</div>

    <div v-if="showDetail && current" class="modal-overlay" @click.self="closeDetail">
      <div class="modal-content card">
        <div class="modal-header">
          <h3>售后详情</h3>
          <button class="close-btn" @click="closeDetail">×</button>
        </div>
        <div class="modal-body">
          <p><strong>售后单号:</strong> {{ current.afterSalesId || ('AS-' + current.id) }}</p>
          <p><strong>商品名称:</strong> {{ current.productName || '-' }}</p>
          <p><strong>售后类型:</strong> {{ current.type || '-' }}</p>
          <p><strong>问题描述:</strong> {{ current.reason || '-' }}</p>
          <p><strong>当前状态:</strong> {{ current.status || '待处理' }}</p>
          <p><strong>申请时间:</strong> {{ formatDateTime(current.createdAt) }}</p>
          <p v-if="current.returnAddress"><strong>退货地址:</strong> {{ current.returnAddress }}</p>
          <p v-if="current.returnContact"><strong>联系人:</strong> {{ current.returnContact }}</p>
          <p v-if="current.returnPhone"><strong>联系电话:</strong> {{ current.returnPhone }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerAfterSales',
  data() {
    return {
      loading: false,
      error: '',
      records: [],
      showDetail: false,
      current: null
    }
  },
  created() {
    this.fetchAfterSales()
  },
  methods: {
    async fetchAfterSales() {
      this.loading = true
      this.error = ''
      try {
        const customerUsername = localStorage.getItem('customerUsername')
        const response = await this.$axios.get('/after-sales', {
          headers: {
            'X-Username': customerUsername || ''
          }
        })
        const raw = Array.isArray(response.data) ? response.data : []
        this.records = raw
          .filter(item => !customerUsername || item.customerName === customerUsername)
          .sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0))
      } catch (err) {
        this.error = '获取售后记录失败'
        console.error(err)
      } finally {
        this.loading = false
      }
    },
    openDetail(item) {
      this.current = item
      this.showDetail = true
    },
    closeDetail() {
      this.showDetail = false
      this.current = null
    },
    formatDateTime(value) {
      if (!value) return '-'
      return new Date(value).toLocaleString('zh-CN')
    },
    statusClass(status) {
      switch (status) {
        case '待处理':
          return 's-pending'
        case '协商中':
          return 's-negotiating'
        case '待退货':
          return 's-returning'
        case '待退款':
          return 's-refunding'
        case '已完成':
          return 's-completed'
        case '已拒绝':
          return 's-rejected'
        default:
          return ''
      }
    }
  }
}
</script>

<style scoped>
.after-sales-page {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px 0;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.records-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.record-card {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}

.line {
  margin-bottom: 6px;
}

.status {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
}

.s-pending { background: #fff3cd; color: #856404; }
.s-negotiating { background: #d1ecf1; color: #0c5460; }
.s-returning { background: #e2e3ff; color: #383d7d; }
.s-refunding { background: #ffe8cc; color: #7d4f00; }
.s-completed { background: #d4edda; color: #155724; }
.s-rejected { background: #f8d7da; color: #721c24; }

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  width: 92%;
  max-width: 520px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.close-btn {
  border: none;
  background: transparent;
  font-size: 22px;
  cursor: pointer;
}
</style>
